import { InviteUserDialogComponent } from './invite-user-dialog/invite-user-dialog.component';

export { InviteUserDialogComponent };

export default [InviteUserDialogComponent];
